<tt-gantt-toolbar
    [ttToolbar]="options.toolbar"
    [ttCriticalPath]="criticalPathEnabled"
    [ttResourceGraph]="resourceGraphEnabled"
    [ttFieldNames]="showFieldNames"
    [ttBackwardPlanning]="backwardPlanningEnabled"
    [ttColumns]="toolbarColumns"
    [ttResourceColumns]="toolbarResourceColumns"
    [ttLoading]="loading"
    [ttSaving]="saving"
    [ttAutoSave]="options.save.autoSave"
    [ttHasChanges]="hasChanges"
    (ttColumnVisibility)="setColumnVisibility($event.propertyKey, $event.visible)"
    (ttColumnOrder)="reorderColumns($event)"
    (ttResetColumns)="resetColumns()"
    (ttResourceColumnVisibility)="setResourceColumnVisibility($event.propertyKey, $event.visible)"
    (ttResourceColumnOrder)="reorderResourceColumns($event)"
    (ttResetResourceColumns)="resetResourceColumns()"
    (ttReload)="reloadFromToolbar()"
    (ttSave)="saveFromToolbar()"
    (ttCriticalPathChange)="setCriticalPath($event)"
    (ttResourceGraphChange)="setResourceGraph($event)"
    (ttFieldNamesChange)="setFieldNames($event)"
    (ttBackwardPlanningChange)="setBackwardPlanning($event)"
></tt-gantt-toolbar>
<div #gantt_viewport class="gantt-chart-container" (pointermove)="onChartPointerMove($event)">
    <div #gantt_here class="gantt-chart" (click)="onResourceCellClick($event, 'click')" (dblclick)="onResourceCellClick($event, 'dblclick')"></div>
    <div
        *ngIf="saveError"
        class="gantt-error-region"
        [style.left.px]="errorToastBounds.left"
        [style.top.px]="errorToastBounds.top"
        [style.width.px]="errorToastBounds.width"
        [style.height.px]="errorToastBounds.height"
        [style.--gantt-error-height]="errorToastBounds.height + 'px'"
    >
        <tt-toast
            class="gantt-error-toast"
            [class.gantt-error-toast--top]="errorToastPosition === 'top'"
            ttType="danger"
            role="alert"
            [ttCloseLabel]="errorToastLabels.close"
            (ttClose)="dismissErrorToast()"
        >
            <span title>
                <span #errorToastText class="gantt-error-text" [class.gantt-error-text--expanded]="errorToastExpanded" [id]="errorToastTextId">{{ errorToastMessage }}</span>
                <button *ngIf="errorToastHasDetails" type="button" class="gantt-error-details" [attr.aria-expanded]="errorToastExpanded" [attr.aria-controls]="errorToastTextId" (click)="toggleErrorToastDetails()">{{ errorToastExpanded ? errorToastLabels.showLess : errorToastLabels.showMore }}</button>
            </span>
        </tt-toast>
    </div>
</div>
